<div class="gpd-full-page">
  <div class="proj-inner-area">
    <div class="gpd-content-container proj-content-area">
      <router-outlet></router-outlet>
    </div>
  </div>

  <dx-toast [(visible)]="favoriteToastVisible" [message]="favoriteMessage" [type]="favoriteToastType"></dx-toast>
</div>
